const riot = require('riot');

riot.tag2('page-bank-edit', '<div class="bg-cream h-full f flex-column"> <div class="sticky t0 z100" data-is="module-header" title="{getTitle()}" close="{true}"> <yield to="right"> <button type="submit" form="amount_form">{t(⁗header.done⁗)}</button> </yield> </div> <form class="px20 pt27 container w-full" id="amount_form" ref="form" onsubmit="{done}"> <div class="fs16 fw6 mb12">{getLabel()}</div> <div class="w-full fs24 fw6 mb24">{amount}{app.utils.getCurrencyText(currency, amount !== 1)}</div> <div class="fs16 fw6 mb20">{t(⁗bank_edit.amount_label⁗)}</div> <div class="w-full relative mb16"> <input class="w-full bg-white rounded-8 border border-dark-012 pl20 pr70 py13 placeholder-opacity-0_5 fs16 fw6" ref="amount" name="amount" placeholder="{t(&quot;bank_edit.amount_placeholder&quot;)}"> <div class="absolute t0 r0 w70 h-full fw6 f fh">{app.utils.getCurrencyText(currency, true)}</div> </div> <div class="w-full relative mb32"> <select class="w-full bg-white rounded-8 border border-dark-012 cursor-pointer py13 px20 fs16" name="direction"> <option each="{direction in [&quot;decrease&quot;, &quot;increase&quot;]}" riot-value="{direction}">{getOptionText(direction)}</option> </select> <div class="absolute t0 r0 pointer-none h-full px16 f fh"> <div class="fs20 icon-arrow_down text-dark-026"></div> </div> </div> <div class="fs16 fw6 mb20">{t(⁗bank_edit.reason_label⁗)}</div> <input class="w-full bg-white rounded-8 border border-dark-012 pl20 py13 placeholder-opacity-0_5 fs16 fw6" name="reason" type="text" placeholder="{getPlaceholder()}"> </form> </div>', '', '', function(opts) {
    this.preload = async({req, res}) => {
      var type = req.params.type;

      var bank_res = app.api.request({
        method: 'get',
        url: '/web/children/' + req.params.id + '/bank/balance',
      });

      var me_res = app.api.request({
        method: 'get',
        url: '/web/me',
      });

      var promises = [
        bank_res,
        me_res,
      ];

      var items = await Promise.all(promises);

      return {
        type,
        child_id: req.params.id,
        amount: type === "account" ? items[0].data.bank_cash || 0 : items[0].data.bank_loan || 0,
        currency: items[1].data.family.currency,
      }
    };

    this.on('show', () => {
      if (this.currency === "JPY" || this.currency === "NTD") {
        this.refs.amount.setAttribute("type", "tel");
      } else {
        this.refs.amount.setAttribute("type", "number");
      }
      this.update();
    });

    this.getTitle = () => {
      return t(`bank_edit.${this.type}_title`);
    };

    this.getLabel = () => {
      return t(`bank_edit.current_${this.type}`);
    };

    this.getOptionText = (value) => {
      return t(`bank_edit.${value}`)
    };

    this.getPlaceholder = () => {
      return t(`bank_edit.reason_placeholder_${this.type}`)
    };

    this.done = async(e) => {
      e.preventDefault();
      e.stopPropagation();

      var url = '/web/children/' + this.child_id + (this.type === "account" ? '/bank/edit' : '/bank/loan/edit');

      var data = {

        amount: this.refs.form.amount.value * (this.refs.form.direction.value === "decrease" ? -1 : 1),
        message: this.refs.form.reason.value,
      };

      try {
        await app.api.request({
          method: "put", url, data,
        })
        spat.modal.alert(t("bank_edit.edit_done"));
        spat.router.push('/');
      }
      catch(error) {

      }

    };
});